export const inr = (n) =>
  "₹" +
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const inrShort = (n) => {
  const v = Number(n || 0);
  if (Math.abs(v) >= 10000000) return "₹" + (v / 10000000).toFixed(2) + " Cr";
  if (Math.abs(v) >= 100000) return "₹" + (v / 100000).toFixed(2) + " L";
  if (Math.abs(v) >= 1000) return "₹" + (v / 1000).toFixed(1) + " K";
  return inr(v);
};

export const num = (n) =>
  Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 3 });

export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(d.length <= 10 ? d + "T00:00:00" : d);
  if (isNaN(dt)) return d;
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${dt.getFullYear()}`;
};

// Display label for a bill: the entered bill number, or "NOACC" when empty.
export const billNo = (b) => {
  const v = (b ?? "").toString().trim();
  return v || "NOACC";
};

export const today = () => new Date().toISOString().slice(0, 10);
export const thisMonth = () => new Date().toISOString().slice(0, 7);
